import { BackIcon } from '@/component/Icons';
import PATH from '@/config/PATH';
import { getRankStatus } from '@/Redux/futures/rank/actions';
import { curRank } from '@/Redux/selector';
import FrameRankBottomMaster from '@assets/web-v3-images/back-rank-bottom-master.png';
import FrameRankBottom from '@assets/web-v3-images/back-rank-bottom.png';
import FrameRankTopMaster from '@assets/web-v3-images/back-rank_top-master.png';
import FrameRankTop from '@assets/web-v3-images/back-rank_top.png';
import imgBtnMaster from '@assets/web-v3-images/guess-price-btn-bg-master.png';
import imgBtnExplorer from '@assets/web-v3-images/guess-price-btn-bg.png';
import imgExplorer from '@assets/web-v3-images/icons/explorer.png';
import imgMaster from '@assets/web-v3-images/icons/master.png';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import BannerText from './components/BannerText';
import Comparison from './components/Comparison';
import DayStreakProgress from './components/DayStreakProgress';
import GradientText from './components/GradientText';
import QuickRule from './components/QuickRule';

const Buttons = ({ src, text, onClick }) => {
	return (
		<button className="relative inline-block btn-click-active" onClick={onClick}>
			<img
				src={src}
				alt=""
				className="w-[550px] h-[50px] sm:h-[80px]"
			/>
			<span
				className="
									text-[14px] sm:text-[30px]
									absolute inset-0
									flex items-center justify-center
									text-white font-semibold uppercase
								"
				style={{
					WebkitTextStroke: "2px #D86B00",
					paintOrder: "stroke fill",
				}}
			>
				{text}
			</span>
		</button>
	)
}

export default function Rank() {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false)

	const { rankStatus } = useSelector(curRank);

	const requiredDays = Number(rankStatus?.required_days) || 7;
	const progressDays = requiredDays - (Number(rankStatus?.progress_days) || 0);
	const displayState = rankStatus?.display_state === 'NO_SUB';
	const displayExpires = rankStatus?.display_state === 'EXPIRED';

	useEffect(() => {
		dispatch(getRankStatus({}));
	}, [dispatch]);

	useEffect(() => {
		if (rankStatus?.show_congrats_popup === true) {
			setOpen(true);
		}
	}, [rankStatus?.show_congrats_popup]);

	const handlePackage = () => {
		navigate(PATH.PACKAGE)
	}

	const renderRankStatus = () => {
		switch (rankStatus?.display_state) {
			case 'NO_SUB':
			case 'EXPIRED':
				return (
					<Buttons
						onClick={handlePackage}
						src={imgBtnExplorer}
						text={t('rank.activate_subscription')}
					/>
				);

			case 'MASTER':
				return (
					<Buttons
						onClick={handlePackage}
						src={imgBtnMaster}
						text={t('rank.maintain_master_status')}
					/>
				);

			default:
				return (
					<DayStreakProgress
						currentDay={rankStatus?.progress_days}
						totalDays={rankStatus?.required_days}
					/>
				);
		}
	};

	return (
		<>
			<div className="relative w-full">
				<img
					src={rankStatus?.rank === "EXPLORER" ? FrameRankTop : FrameRankTopMaster}
					className="w-full h-[450px] sm:h-auto block"
					alt=""
				/>
				<div className="absolute text-center top-0 left-0 w-full pt-6 sm:pt-15">
					<div onClick={() => navigate(-1)} className='btn-click-active'>
						<BackIcon className="w-[31px] sm:w-[60px] h-auto ml-3.5 sm:ml-6" />
					</div>
					<GradientText
						className="text-4xl md:text-7xl">{rankStatus?.rank === "EXPLORER" ? "Shwe Explorer" : "Shwe Master"}</GradientText>
					<div className='px-[5%] flex flex-col justify-center items-center'>
						<div className="relative w-full py-3"
							style={{
								backgroundImage: 'linear-gradient(90deg, rgba(190,101,65,0) 0%, rgba(172,87,53,1) 50%, rgba(190,101,65,0) 100%)',
							}}
						>
							<div
								className="absolute top-0 left-0 w-full h-[3px]"
								style={{
									backgroundImage: 'linear-gradient(90deg, rgba(250,236,169,0) 0%, rgba(250,236,169,1) 50%, rgba(250,236,169,0) 100%)',
									mixBlendMode: 'plus-lighter',
								}}
							/>

							<div
								className="absolute bottom-0 left-0 w-full h-[3px]"
								style={{
									backgroundImage: 'linear-gradient(90deg, rgba(250,236,169,0) 0%, rgba(250,236,169,1) 50%, rgba(250,236,169,0) 100%)',
									mixBlendMode: 'plus-lighter',
								}}
							/>
							<BannerText className="text-[17px] md:text-3xl">{
								displayExpires ? t('rank.your_shwe_master_status_has_expired') :
									rankStatus?.rank === "EXPLORER" ?
										displayState ?
											t("rank.unlock_shwe_master_in_just_7_days").replace("_LP_", progressDays) :
											t("rank.only_n_days_left_to_become_Shwe_Master").replace("_LP_", progressDays)
										:
										progressDays === requiredDays + 1 ?
											t('rank.you_are_a_Shwe_Master') : t("rank.congratulations_youre_now_a_shwe_master")
							}
							</BannerText>
						</div>
						<BannerText className="text-[12px] md:text-[22px] italic !font-semibold pt-2 sm:pt-6">
							{
								displayExpires ? t('rank.reactivate_any_subscription_and_stay') :
									rankStatus?.rank === "EXPLORER" ?
										displayState ?
											t("rank.subscribe_and_stay_active_for_7_days_to_earn_bigger").replace("_LP_", progressDays) :
											t("rank.keep_subscription_active")
										:
										t("rank.keep_any_subscription_active_to_maintain_your_master")
							}
						</BannerText>
						<img src={rankStatus?.rank === "EXPLORER" ? imgExplorer : imgMaster} alt="" className='w-full sm:pt-5 px-[30%] sm:px-[25%]' />
						{renderRankStatus()}
					</div>
				</div>
			</div>
			<div className="relative w-full -mt-[2px]">
				<img
					src={rankStatus?.rank === "EXPLORER" ? FrameRankBottom : FrameRankBottomMaster}
					className="absolute inset-0 w-full h-full object-fill"
					alt=""
				/>
				<div className="relative w-full px-4 py-6">
					<Comparison data={rankStatus?.rank_benefit || {}} />
					<br />
					<QuickRule data={rankStatus?.rank_benefit?.quick_rule || {}} />
				</div>
			</div>

			{/* popup chúc mừng vừa lên Master show ở home page */}
			{/* <Congratulation
				open={open}
				onOpenChange={setOpen}
				title={t('rank.congratulation')}
				textDescribe={t('rank.you_now_a_Shwe_Master')}
				textBtn={t('rank.ok')}
				imgs={imgCongratulationRank}
				handleClick={() => setOpen(false)}
			/> */}
		</>
	)
}
